import React from 'react';

// Import components
import { SliderArrow } from 'components/elements';

export const sliderConfig = {
	infinite: false,
	dots: false,
	rows: 1,
	slidesToScroll: 1,
	slidesToShow: 5,
	initialSlide: 0,
	nextArrow: <SliderArrow direction="right" />,
	prevArrow: <SliderArrow direction="left" />,
	variableWidth: true
};
